export default "__VITE_ASSET__CkWI7ulI__"